import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RELEASE_NOTES, ReleaseNote } from './release-notes.data';

@Component({
  selector: 'app-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.scss'],
  standalone: false
})
export class ReleaseNotesComponent {
  /** Newest release, featured at the top of the page. */
  readonly latest: ReleaseNote | undefined = RELEASE_NOTES[0];

  /** Previously published releases, newest first. */
  readonly history: ReleaseNote[] = RELEASE_NOTES.slice(1);

  constructor(private router: Router) {}

  navigateToHome(): void {
    this.router.navigate(['/']);
  }

  navigateToSignup(): void {
    this.router.navigate(['/auth/signup']);
  }

  trackById(_index: number, note: ReleaseNote): string {
    return note.id;
  }
}
